// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
export function avoid(...args: any[]): void {}
